import React from 'react';
import { bool } from 'prop-types';

const IconWatchlist = ({ isActive }) => (
  isActive ? 
    (
      <svg 
        width="24" 
        height="24" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          fillRule="evenodd" 
          clipRule="evenodd" 
          d="M12 2C12.3788 2 12.725 2.214 12.8944 2.55279L15.6667 8.09732L21.1644 9.01361C21.5143 9.07193 21.8072 9.31129 21.934 9.64263C22.0608 9.97396 22.0025 10.3477 21.7809 10.6247L18.0598 15.276L18.9864 20.8356C19.0482 21.2066 18.8967 21.5809 18.5941 21.8044C18.2916 22.0278 17.8892 22.0626 17.5528 21.8944L12 19.118L6.44723 21.8944C6.11081 22.0626 5.70846 22.0278 5.40591 21.8044C5.10336 21.5809 4.95178 21.2066 5.01362 20.8356L5.94021 15.276L2.21914 10.6247C1.99752 10.3477 1.93927 9.97396 2.06605 9.64263C2.19283 9.31129 2.48567 9.07193 2.83561 9.01361L8.33332 8.09732L11.1056 2.55279C11.275 2.214 11.6212 2 12 2Z" 
          fill="#3A83F9"
        />
      </svg>
    ) : (
      <svg 
        width="24" 
        height="24" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          fillRule="evenodd" 
          clipRule="evenodd" 
          d="M12 2C12.3788 2 12.725 2.214 12.8944 2.55279L15.6667 8.09732L21.1644 9.01361C21.5143 9.07193 21.8072 9.31129 21.934 9.64263C22.0608 9.97396 22.0025 10.3477 21.7809 10.6247L18.0598 15.276L18.9864 20.8356C19.0482 21.2066 18.8967 21.5809 18.5941 21.8044C18.2916 22.0278 17.8892 22.0626 17.5528 21.8944L12 19.118L6.44723 21.8944C6.11081 22.0626 5.70846 22.0278 5.40591 21.8044C5.10336 21.5809 4.95178 21.2066 5.01362 20.8356L5.94021 15.276L2.21914 10.6247C1.99752 10.3477 1.93927 9.97396 2.06605 9.64263C2.19283 9.31129 2.48567 9.07193 2.83561 9.01361L8.33332 8.09732L11.1056 2.55279C11.275 2.214 11.6212 2 12 2ZM12 5.23607L9.89444 9.44721C9.75136 9.73337 9.47999 9.9338 9.16441 9.98639L4.84559 10.7062L7.78088 14.3753C7.95839 14.5972 8.03312 14.8841 7.98641 15.1644L7.30925 19.2274L11.5528 17.1056C11.8343 16.9648 12.1657 16.9648 12.4472 17.1056L16.6908 19.2274L16.0136 15.1644C15.9669 14.8841 16.0416 14.5972 16.2191 14.3753L19.1544 10.7062L14.8356 9.98639C14.52 9.9338 14.2487 9.73337 14.1056 9.44721L12 5.23607Z" fill="#06090D"
        />
    </svg>

  )
)

IconWatchlist.propTypes = {
  isActive: bool,
};

IconWatchlist.defaultProps = {
  isActive: false
}

export default IconWatchlist;
